import $ from 'jquery';
import debounce from './lib/debounce';

import './style.scss';

$(function () {
  const $scrollTop = $('<button/>', { class: 'scroll-to-top' })
    .on('click', (evt) => {
      evt.preventDefault();
      console.log('scrolling to top');

      window.scroll({
        top: 0,
        left: 0,
        behavior: 'smooth',
      });
    })
    .append('<span class="dashicons dashicons-arrow-up-alt2"></span>')
    .appendTo(document.body);

  $(window).on(
    'scroll',
    debounce(() => {
      if (window.scrollY > 1000) {
        $scrollTop.addClass('-visible');
      } else {
        $scrollTop.removeClass('-visible');
      }
    }, 100)
  );

  $('.product-specs-link__link').on('click', (evt) => {
    evt.preventDefault();
    const $specs = $('.product-specs');

    window.scroll({
      top: $specs.offset().top - 40,
      behavior: 'smooth',
    });
  });
});
